var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckcircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7927 7.38674V8.00007C14.7919 9.43769 14.3264 10.8365 13.4656 11.988C12.6048 13.1394 11.3949 13.9817 10.0163 14.3893C8.63764 14.797 7.16419 14.748 5.81566 14.2498C4.46714 13.7516 3.31579 12.8308 2.53332 11.6248C1.75086 10.4188 1.37921 8.99211 1.4738 7.55761C1.56839 6.12311 2.12416 4.75762 3.0582 3.66479C3.99225 2.57195 5.25454 1.81033 6.65681 1.4935C8.05908 1.17668 9.5262 1.32163 10.8394 1.90674M14.7927 2.66674L8.12602 9.34007L6.12602 7.34007",
    stroke: "#007AFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.125977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircle);
export default __webpack_public_path__ + "static/media/Check circle.f207d1734dafc4fb70c59c5dbcff3a90.svg";
export { ForwardRef as ReactComponent };